"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function setUser(userData) {
    var _a;
    if (!((_a = window.puiFaro) === null || _a === void 0 ? void 0 : _a.api)) {
        throw new Error("Faro instance is not initialized. Please call initObservability before calling setUser.");
    }
    window.puiFaro.api.setUser(userData);
}
exports.default = setUser;
//# sourceMappingURL=setUser.js.map